import router from '@/router';
export default {
  state: {
    saleRecordList: [],
    paymentTypeList: [],
    reportInfo: {},
  },
  getters: {},
  mutations: {
    setSaleRecordList(state: any, data: any) {
      state.saleRecordList = data.list.map((item: any) => {
        item.tradeTime = router.app.$format(item.tradeTime);
        return item;
      });
    },
    setPaymentTypeList(state: any, data: any) {
      if (data.length === 0) {
        state.paymentTypeList = [];
      } else {
        state.paymentTypeList = data.map((item: any) => {
          return {
            paymentCount: '',
            paymentTotalAmount: '',
            paymentWayId: item.dictItemId,
            externalCode: item.itemKey,
            paymentName: item.itemNameCn,
          }
        })
      }
    },
    setReportInfo(state: any, data: any) {
      console.log(data);
      data.reportTime = router.app.$format(data.reportTime, 'YYYY-MM-DD HH:mm').replace(/-/g, '.');
      data.tradeTime = router.app.$format(data.tradeTime).replace(/-/g, '.');
      data.auditTime = router.app.$format(data.auditTime).replace(/-/g, '.');
      data.totleAmount = 0;
      data.totleCount = 0;
      data.saleFlows = data.saleFlows.map((item: any) => {
        data.totleAmount += item.paymentSum || 0;
        data.totleCount += item.paymentCount || 0;
        item.paymentSum = item.paymentSum.toFixed(2);
        return item
      })
      data.urls = data.urls.map((item: any) => {
        return { url: item };
      })
      data.urlsLength = data.urls.length || 0;
      data.totleAmount = data.totleAmount.toFixed(2);
      data.totleCount = data.totleCount
      // data.totleCount = data.totleCount.toFixed(2);
      console.log(data)
      state.reportInfo = data
    },
  },
  actions: {
    async getSaleRecordList({ commit }: any, params: any) {
      params.entityId = router.app.$global.parentBusinessEntityId ? router.app.$global.parentBusinessEntityId : router.app.$global.tenantId
      params.entityType = router.app.$global.parentBusinessEntityTypeId ? router.app.$global.parentBusinessEntityTypeId : router.app.$global.tenantType
      // console.log(router.app.$global);
      const { error, success }: any = await router.app.$request('REPORT_LIST', params);
      if (success) {
        commit('setSaleRecordList', success.data);
      }
      return { error, success };
    },
    async getPaymentTypeList({ commit }: any, params: any) {
      commit('setPaymentTypeList', []);
      const { error, success }: any = await router.app.$request('PAYMENT_LIST', params);
      if (success) {
        commit('setPaymentTypeList', success.data);
      }
      return { error, success };
    },
    async getReportInfo({ commit }: any, params: any) {
      const { error, success }: any = await router.app.$request('REPORT_INFO', params);
      if (success) {
        commit('setReportInfo', success.data);
      }
      return { error, success };
    },
  }
}